// src/pages/Dashboard/Admin/DepensesRecettesDashboard/components/AccountingFiltersCard.jsx

import React from "react";
import { FaFilter, FaSearch, FaSyncAlt, FaTimes } from "react-icons/fa";

export default function AccountingFiltersCard({
  filters,
  setFilter,
  resetFilters,
  saisons,
  categories,
  planComptables,
  loading,
  refreshAll,
  filteredCount,
  totalCount,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Recherche
            </p>

            <h2 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaFilter className="text-indigo-600 dark:text-indigo-300" />
              Filtres du journal
            </h2>
          </div>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={resetFilters}
              className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaTimes />
              Réinitialiser
            </button>

            <button
              type="button"
              onClick={refreshAll}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>

        <div className="grid gap-3 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
              Recherche libre
            </label>

            <div className="relative">
              <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

              <input
                value={filters.q}
                onChange={(event) => setFilter("q", event.target.value)}
                placeholder="Désignation, bénéficiaire, montant, règlement..."
                className="w-full rounded-2xl border border-slate-200 bg-white py-2.5 pl-10 pr-3 text-sm font-medium text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
              />
            </div>
          </div>

          <FilterSelect
            label="Saison"
            value={filters.saison}
            onChange={(value) => setFilter("saison", value)}
            options={saisons.map((season) => ({
              value: season,
              label: `Saison ${season}`,
            }))}
            emptyLabel="Toutes saisons"
            className="lg:col-span-2"
          />

          <FilterSelect
            label="Type"
            value={filters.type}
            onChange={(value) => setFilter("type", value)}
            options={[
              { value: "Dépense", label: "Dépense" },
              { value: "Recette", label: "Recette" },
            ]}
            emptyLabel="Tous types"
            className="lg:col-span-2"
          />

          <FilterSelect
            label="Catégorie"
            value={filters.categorie}
            onChange={(value) => setFilter("categorie", value)}
            options={categories.map((category) => ({
              value: category,
              label: category,
            }))}
            emptyLabel="Toutes catégories"
            className="lg:col-span-2"
          />

          <FilterSelect
            label="Compte"
            value={filters.planComptableId}
            onChange={(value) => setFilter("planComptableId", value)}
            options={planComptables.map((plan) => ({
              value: plan.id,
              label: `${plan.code} — ${plan.intitule}`,
            }))}
            emptyLabel="Tous comptes"
            className="lg:col-span-2"
          />
        </div>

        <div className="mt-4 flex flex-wrap gap-2 text-xs text-slate-600 dark:text-slate-300">
          <span className="rounded-full bg-slate-100 px-3 py-1 font-bold dark:bg-slate-800">
            {filteredCount} opération(s) filtrée(s)
          </span>

          <span className="rounded-full bg-slate-100 px-3 py-1 font-bold dark:bg-slate-800">
            {totalCount} opération(s) au total
          </span>
        </div>
      </div>
    </section>
  );
}

function FilterSelect({
  label,
  value,
  onChange,
  options,
  emptyLabel,
  className = "",
}) {
  return (
    <div className={className}>
      <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
      >
        <option value="">{emptyLabel}</option>

        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}